import { render, staticRenderFns } from "./ValidateWorkDialog.vue?vue&type=template&id=63528232&scoped=true&"
import script from "./ValidateWorkDialog.vue?vue&type=script&lang=js&"
export * from "./ValidateWorkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63528232",
  null
  
)

export default component.exports